<template>
  <a
    v-if="button.action && button.action === 'Modal Popup'"
    :data-id="button.linkUrl"
    class="btn--modal"
    :class="buttonClasses"
    @click.prevent="openModal(button.linkUrl)"
    >{{ button.text }}</a
  >
  <LocaleLink
    v-else-if="button.style === 'App Store' || button.style === 'Google Play'"
    :link="button.linkUrl"
  >
    <img
      v-if="button.style === 'App Store'"
      class="inline button--app"
      src="https://images.ctfassets.net/bx9krvy0u3sx/50MyBJwhdNzow664gbDwJU/565fdb71adf0792818b3552b877ebd3f/apple.jpg"
      alt="app store button"
    />
    <img
      v-else-if="button.style === 'Google Play'"
      class="inline button--app"
      src="https://images.ctfassets.net/bx9krvy0u3sx/5zFPvFkg8o4Khh7tbfOCWe/65c273838647096655763e996bbe1c48/google.jpg"
      alt="google play button"
    />
  </LocaleLink>
  <LocaleLink v-else :link="button.linkUrl" :class="buttonClasses">{{
    button.text
  }}</LocaleLink>
</template>
<style lang="scss" scoped>
  .button--app {
    max-height: 40px;

    &:first-of-type {
      padding-right: 12px;
    }
  }
</style>
<script>
  import LocaleLink from '../LocaleLink';
  import fadeIn from '../../mixins/fadeIn.js';
  export default {
    components: {
      LocaleLink
    },
    mixins: [fadeIn],
    props: {
      button: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        buttonClasses: ''
      };
    },
    created() {
      const styles = {
        'Red Primary': 'btn btn--red btn--red:hover',
        'Red Secondary': 'btn btn--red-secondary btn--red:hover',
        'Teal Primary': 'btn btn--teal btn--teal:hover',
        'Teal Secondary': 'btn btn--teal-secondary btn--teal:hover',
        'White Secondary': 'btn btn--white-secondary btn--white:hover',
        'Green Secondary Open': 'btn btn--green-secondary btn--green:hover',
        'Blue Primary': 'btn btn--blue btn--blue:hover',
        'Blue Secondary Square': 'btn btn--blue-secondary btn--blue:hover'
      };
      const icons = {
        'Link Out': 'btn--icon btn--icon-link',
        Download: 'btn--icon btn--icon-download',
        Play: 'btn--icon btn--icon-video'
      };
      this.buttonClasses =
        this.button.style && this.button.icon
          ? `md:mr-1/2 ${styles[this.button.style]} ${icons[this.button.icon]}`
          : this.button.style
          ? `md:mr-1/2 ${styles[this.button.style]}`
          : '';
    },
    methods: {
      openModal(id) {
        const modal = document.querySelector(`#${id}`);
        this.fadeIn(modal, 'block');
      }
    }
  };
</script>
